export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	bulbasaur: {
		isNonstandard: null,
	},
	ivysaur: {
		isNonstandard: null,
	},
	venusaur: {
		isNonstandard: null,
	},
	venusaurmega: {
		isNonstandard: null,
	},
	charmander: {
		isNonstandard: null,
	},
	charmeleon: {
		isNonstandard: null,
	},
	charizard: {
		isNonstandard: null,
	},
	charizardmegax: {
		isNonstandard: null,
	},
	charizardmegay: {
		isNonstandard: null,
	},
	squirtle: {
		isNonstandard: null,
	},
	wartortle: {
		isNonstandard: null,
	},
	blastoise: {
		isNonstandard: null,
	},
	blastoisemega: {
		isNonstandard: null,
	},
	weedle: {
		isNonstandard: null,
	},
	kakuna: {
		isNonstandard: null,
	},
	beedrill: {
		isNonstandard: null,
	},
	beedrillmega: {
		isNonstandard: null,
	},
	pidgey: {
		isNonstandard: null,
	},
	pidgeotto: {
		isNonstandard: null,
	},
	pidgeot: {
		isNonstandard: null,
	},
	pidgeotmega: {
		isNonstandard: null,
	},
	ekans: {
		isNonstandard: null,
	},
	arbok: {
		isNonstandard: null,
	},
	pikachu: {
		isNonstandard: null,
	},
	pikachuoriginal: {
		isNonstandard: "Past",
	},
	pikachuhoenn: {
		isNonstandard: "Past",
	},
	pikachusinnoh: {
		isNonstandard: "Past",
	},
	pikachuunova: {
		isNonstandard: "Past",
	},
	pikachukalos: {
		isNonstandard: "Past",
	},
	pikachualola: {
		isNonstandard: "Past",
	},
	pikachupartner: {
		isNonstandard: "Past",
	},
	pikachuworld: {
		isNonstandard: "Past",
	},
	raichu: {
		isNonstandard: null,
	},
	raichualola: {
		isNonstandard: null,
	},
	raichumegax: {
		isNonstandard: null,
	},
	raichumegay: {
		isNonstandard: null,
	},
	sandshrew: {
		isNonstandard: "Past",
	},
	sandshrewalola: {
		isNonstandard: "Past",
	},
	sandslash: {
		isNonstandard: "Past",
	},
	sandslashalola: {
		isNonstandard: "Past",
	},
	clefairy: {
		isNonstandard: null,
	},
	clefable: {
		isNonstandard: null,
	},
	clefablemega: {
		isNonstandard: null,
	},
	vulpix: {
		isNonstandard: "Past",
	},
	vulpixalola: {
		isNonstandard: "Past",
	},
	ninetales: {
		isNonstandard: "Past",
	},
	ninetalesalola: {
		isNonstandard: "Past",
	},
	igglybuff: {
		isNonstandard: null,
	},
	jigglypuff: {
		isNonstandard: null,
	},
	wigglytuff: {
		isNonstandard: null,
	},
	zubat: {
		isNonstandard: null,
	},
	golbat: {
		isNonstandard: null,
	},
	crobat: {
		isNonstandard: null,
	},
	oddish: {
		isNonstandard: "Past",
	},
	gloom: {
		isNonstandard: "Past",
	},
	vileplume: {
		isNonstandard: "Past",
	},
	venonat: {
		isNonstandard: "Past",
	},
	venomoth: {
		isNonstandard: "Past",
	},
	diglett: {
		isNonstandard: "Past",
	},
	diglettalola: {
		isNonstandard: "Past",
	},
	dugtrio: {
		isNonstandard: "Past",
	},
	dugtrioalola: {
		isNonstandard: "Past",
	},
	meowth: {
		isNonstandard: null,
	},
	meowthalola: {
		isNonstandard: null,
	},
	meowthgalar: {
		isNonstandard: null,
	},
	persian: {
		isNonstandard: null,
	},
	persianalola: {
		isNonstandard: null,
	},
	perrserker: {
		isNonstandard: null,
	},
	psyduck: {
		isNonstandard: "Past",
	},
	golduck: {
		isNonstandard: "Past",
	},
	mankey: {
		isNonstandard: null,
	},
	primeape: {
		isNonstandard: null,
	},
	annihilape: {
		isNonstandard: null,
	},
	growlithe: {
		isNonstandard: "Past",
	},
	growlithehisui: {
		isNonstandard: "Past",
	},
	arcanine: {
		isNonstandard: "Past",
	},
	arcaninehisui: {
		isNonstandard: "Past",
	},
	poliwag: {
		isNonstandard: "Past",
	},
	poliwhirl: {
		isNonstandard: "Past",
	},
	poliwrath: {
		isNonstandard: "Past",
	},
	abra: {
		isNonstandard: null,
	},
	kadabra: {
		isNonstandard: null,
	},
	alakazam: {
		isNonstandard: null,
	},
	alakazammega: {
		isNonstandard: null,
	},
	machop: {
		isNonstandard: null,
	},
	machoke: {
		isNonstandard: null,
	},
	machamp: {
		isNonstandard: null,
	},
	bellsprout: {
		isNonstandard: null,
	},
	weepinbell: {
		isNonstandard: null,
	},
	victreebel: {
		isNonstandard: null,
	},
	victreebelmega: {
		isNonstandard: null,
	},
	tentacool: {
		isNonstandard: "Past",
	},
	tentacruel: {
		isNonstandard: "Past",
	},
	geodude: {
		isNonstandard: "Past",
	},
	geodudealola: {
		isNonstandard: "Past",
	},
	graveler: {
		isNonstandard: "Past",
	},
	graveleralola: {
		isNonstandard: "Past",
	},
	golem: {
		isNonstandard: "Past",
	},
	golemalola: {
		isNonstandard: "Past",
	},
	slowpoke: {
		isNonstandard: null,
	},
	slowpokegalar: {
		isNonstandard: null,
	},
	slowbro: {
		isNonstandard: null,
	},
	slowbromega: {
		isNonstandard: null,
	},
	slowbrogalar: {
		isNonstandard: null,
	},
	magnemite: {
		isNonstandard: "Past",
	},
	magneton: {
		isNonstandard: "Past",
	},
	magnezone: {
		isNonstandard: "Past",
	},
	farfetchd: {
		isNonstandard: null,
	},
	farfetchdgalar: {
		isNonstandard: null,
	},
	sirfetchd: {
		isNonstandard: null,
	},
	doduo: {
		isNonstandard: "Past",
	},
	dodrio: {
		isNonstandard: "Past",
	},
	seel: {
		isNonstandard: "Past",
	},
	dewgong: {
		isNonstandard: "Past",
	},
	grimer: {
		isNonstandard: "Past",
	},
	grimeralola: {
		isNonstandard: "Past",
	},
	muk: {
		isNonstandard: "Past",
	},
	mukalola: {
		isNonstandard: "Past",
	},
	shellder: {
		isNonstandard: "Past",
	},
	cloyster: {
		isNonstandard: "Past",
	},
	gastly: {
		isNonstandard: null,
	},
	haunter: {
		isNonstandard: null,
	},
	gengar: {
		isNonstandard: null,
	},
	gengarmega: {
		isNonstandard: null,
	},
	onix: {
		isNonstandard: null,
	},
	drowzee: {
		isNonstandard: "Past",
	},
	hypno: {
		isNonstandard: "Past",
	},
	voltorb: {
		isNonstandard: "Past",
	},
	voltorbhisui: {
		isNonstandard: "Past",
	},
	electrode: {
		isNonstandard: "Past",
	},
	electrodehisui: {
		isNonstandard: "Past",
	},
	exeggcute: {
		isNonstandard: "Past",
	},
	exeggutor: {
		isNonstandard: "Past",
	},
	exeggutoralola: {
		isNonstandard: "Past",
	},
	cubone: {
		isNonstandard: null,
	},
	marowak: {
		isNonstandard: null,
	},
	marowakalola: {
		isNonstandard: null,
	},
	hitmonlee: {
		isNonstandard: "Past",
	},
	hitmonchan: {
		isNonstandard: "Past",
	},
	koffing: {
		isNonstandard: "Past",
	},
	weezing: {
		isNonstandard: "Past",
	},
	weezinggalar: {
		isNonstandard: "Past",
	},
	rhyhorn: {
		isNonstandard: "Past",
	},
	rhydon: {
		isNonstandard: "Past",
	},
	chansey: {
		isNonstandard: "Past",
	},
	kangaskhan: {
		isNonstandard: null,
	},
	kangaskhanmega: {
		isNonstandard: null,
	},
	horsea: {
		isNonstandard: "Past",
	},
	seadra: {
		isNonstandard: "Past",
	},
	staryu: {
		isNonstandard: null,
	},
	starmie: {
		isNonstandard: null,
	},
	starmiemega: {
		isNonstandard: null,
	},
	mimejr: {
		isNonstandard: null,
	},
	mrmime: {
		isNonstandard: null,
	},
	mrmimegalar: {
		isNonstandard: null,
	},
	mrrime: {
		isNonstandard: null,
	},
	scyther: {
		isNonstandard: null,
	},
	electabuzz: {
		isNonstandard: "Past",
	},
	magmar: {
		isNonstandard: "Past",
	},
	pinsir: {
		isNonstandard: null,
	},
	pinsirmega: {
		isNonstandard: null,
	},
	tauros: {
		isNonstandard: "Past",
	},
	taurospaldeacombat: {
		isNonstandard: "Past",
	},
	taurospaldeablaze: {
		isNonstandard: "Past",
	},
	taurospaldeaaqua: {
		isNonstandard: "Past",
	},
	magikarp: {
		isNonstandard: null,
	},
	gyarados: {
		isNonstandard: null,
	},
	gyaradosmega: {
		isNonstandard: null,
	},
	lapras: {
		isNonstandard: "Past",
	},
	ditto: {
		isNonstandard: "Past",
	},
	eevee: {
		isNonstandard: null,
	},
	vaporeon: {
		isNonstandard: null,
	},
	jolteon: {
		isNonstandard: null,
	},
	flareon: {
		isNonstandard: null,
	},
	porygon: {
		isNonstandard: null,
	},
	porygon2: {
		isNonstandard: null,
	},
	porygonz: {
		isNonstandard: null,
	},
	aerodactyl: {
		isNonstandard: null,
	},
	aerodactylmega: {
		isNonstandard: null,
	},
	snorlax: {
		isNonstandard: "Past",
	},
	articuno: {
		isNonstandard: "Past",
	},
	articunogalar: {
		isNonstandard: "Past",
	},
	zapdos: {
		isNonstandard: "Past",
	},
	zapdosgalar: {
		isNonstandard: "Past",
	},
	moltres: {
		isNonstandard: "Past",
	},
	moltresgalar: {
		isNonstandard: "Past",
	},
	dratini: {
		isNonstandard: null,
	},
	dragonair: {
		isNonstandard: null,
	},
	dragonite: {
		isNonstandard: null,
	},
	dragonitemega: {
		isNonstandard: null,
	},
	mewtwo: {
		isNonstandard: null,
	},
	mewtwomegax: {
		isNonstandard: null,
	},
	mewtwomegay: {
		isNonstandard: null,
	},
	mew: {
		isNonstandard: "Past",
	},
	chikorita: {
		isNonstandard: null,
	},
	bayleef: {
		isNonstandard: null,
	},
	meganium: {
		isNonstandard: null,
	},
	meganiummega: {
		isNonstandard: null,
	},
	cyndaquil: {
		isNonstandard: "Past",
	},
	quilava: {
		isNonstandard: "Past",
	},
	typhlosion: {
		isNonstandard: "Past",
	},
	typhlosionhisui: {
		isNonstandard: "Past",
	},
	totodile: {
		isNonstandard: null,
	},
	croconaw: {
		isNonstandard: null,
	},
	feraligatr: {
		isNonstandard: null,
	},
	feraligatrmega: {
		isNonstandard: null,
	},
	sentret: {
		isNonstandard: "Past",
	},
	furret: {
		isNonstandard: "Past",
	},
	hoothoot: {
		isNonstandard: "Past",
	},
	noctowl: {
		isNonstandard: "Past",
	},
	spinarak: {
		isNonstandard: null,
	},
	ariados: {
		isNonstandard: null,
	},
	chinchou: {
		isNonstandard: "Past",
	},
	lanturn: {
		isNonstandard: "Past",
	},
	pichu: {
		isNonstandard: null,
	},
	cleffa: {
		isNonstandard: null,
	},
	mareep: {
		isNonstandard: null,
	},
	flaaffy: {
		isNonstandard: null,
	},
	ampharos: {
		isNonstandard: null,
	},
	ampharosmega: {
		isNonstandard: null,
	},
	bellossom: {
		isNonstandard: "Past",
	},
	marill: {
		isNonstandard: "Past",
	},
	azumarill: {
		isNonstandard: "Past",
	},
	sudowoodo: {
		isNonstandard: "Past",
	},
	politoed: {
		isNonstandard: "Past",
	},
	hoppip: {
		isNonstandard: "Past",
	},
	skiploom: {
		isNonstandard: "Past",
	},
	jumpluff: {
		isNonstandard: "Past",
	},
	aipom: {
		isNonstandard: "Past",
	},
	sunkern: {
		isNonstandard: "Past",
	},
	sunflora: {
		isNonstandard: "Past",
	},
	yanma: {
		isNonstandard: "Past",
	},
	wooper: {
		isNonstandard: "Past",
	},
	wooperpaldea: {
		isNonstandard: "Past",
	},
	quagsire: {
		isNonstandard: "Past",
	},
	espeon: {
		isNonstandard: null,
	},
	umbreon: {
		isNonstandard: null,
	},
	murkrow: {
		isNonstandard: "Past",
	},
	slowking: {
		isNonstandard: null,
	},
	slowkinggalar: {
		isNonstandard: null,
	},
	misdreavus: {
		isNonstandard: "Past",
	},
	girafarig: {
		isNonstandard: "Past",
	},
	pineco: {
		isNonstandard: "Past",
	},
	forretress: {
		isNonstandard: "Past",
	},
	dunsparce: {
		isNonstandard: "Past",
	},
	gligar: {
		isNonstandard: "Past",
	},
	steelix: {
		isNonstandard: null,
	},
	steelixmega: {
		isNonstandard: null,
	},
	snubbull: {
		isNonstandard: "Past",
	},
	granbull: {
		isNonstandard: "Past",
	},
	qwilfish: {
		isNonstandard: null,
	},
	qwilfishhisui: {
		isNonstandard: null,
	},
	overqwil: {
		isNonstandard: null,
	},
	scizor: {
		isNonstandard: null,
	},
	scizormega: {
		isNonstandard: null,
	},
	heracross: {
		isNonstandard: null,
	},
	heracrossmega: {
		isNonstandard: null,
	},
	sneasel: {
		isNonstandard: "Past",
	},
	sneaselhisui: {
		isNonstandard: "Past",
	},
	teddiursa: {
		isNonstandard: "Past",
	},
	ursaring: {
		isNonstandard: "Past",
	},
	slugma: {
		isNonstandard: "Past",
	},
	magcargo: {
		isNonstandard: "Past",
	},
	swinub: {
		isNonstandard: "Past",
	},
	piloswine: {
		isNonstandard: "Past",
	},
	delibird: {
		isNonstandard: null,
	},
	skarmory: {
		isNonstandard: null,
	},
	skarmorymega: {
		isNonstandard: null,
	},
	houndour: {
		isNonstandard: null,
	},
	houndoom: {
		isNonstandard: null,
	},
	houndoommega: {
		isNonstandard: null,
	},
	kingdra: {
		isNonstandard: "Past",
	},
	phanpy: {
		isNonstandard: "Past",
	},
	donphan: {
		isNonstandard: "Past",
	},
	stantler: {
		isNonstandard: "Past",
	},
	smeargle: {
		isNonstandard: "Past",
	},
	tyrogue: {
		isNonstandard: "Past",
	},
	hitmontop: {
		isNonstandard: "Past",
	},
	elekid: {
		isNonstandard: "Past",
	},
	magby: {
		isNonstandard: "Past",
	},
	blissey: {
		isNonstandard: "Past",
	},
	raikou: {
		isNonstandard: "Past",
	},
	entei: {
		isNonstandard: "Past",
	},
	suicune: {
		isNonstandard: "Past",
	},
	larvitar: {
		isNonstandard: null,
	},
	pupitar: {
		isNonstandard: null,
	},
	tyranitar: {
		isNonstandard: null,
	},
	tyranitarmega: {
		isNonstandard: null,
	},
	lugia: {
		isNonstandard: "Past",
	},
	hooh: {
		isNonstandard: "Past",
	},
	treecko: {
		isNonstandard: null,
	},
	grovyle: {
		isNonstandard: null,
	},
	sceptile: {
		isNonstandard: null,
	},
	sceptilemega: {
		isNonstandard: null,
	},
	torchic: {
		isNonstandard: null,
	},
	combusken: {
		isNonstandard: null,
	},
	blaziken: {
		isNonstandard: null,
	},
	blazikenmega: {
		isNonstandard: null,
	},
	mudkip: {
		isNonstandard: null,
	},
	marshtomp: {
		isNonstandard: null,
	},
	swampert: {
		isNonstandard: null,
	},
	swampertmega: {
		isNonstandard: null,
	},
	poochyena: {
		isNonstandard: "Past",
	},
	mightyena: {
		isNonstandard: "Past",
	},
	lotad: {
		isNonstandard: "Past",
	},
	lombre: {
		isNonstandard: "Past",
	},
	ludicolo: {
		isNonstandard: "Past",
	},
	seedot: {
		isNonstandard: "Past",
	},
	nuzleaf: {
		isNonstandard: "Past",
	},
	shiftry: {
		isNonstandard: "Past",
	},
	wingull: {
		isNonstandard: "Past",
	},
	pelipper: {
		isNonstandard: "Past",
	},
	ralts: {
		isNonstandard: null,
	},
	kirlia: {
		isNonstandard: null,
	},
	gardevoir: {
		isNonstandard: null,
	},
	gardevoirmega: {
		isNonstandard: null,
	},
	surskit: {
		isNonstandard: "Past",
	},
	masquerain: {
		isNonstandard: "Past",
	},
	shroomish: {
		isNonstandard: "Past",
	},
	breloom: {
		isNonstandard: "Past",
	},
	slakoth: {
		isNonstandard: "Past",
	},
	vigoroth: {
		isNonstandard: "Past",
	},
	slaking: {
		isNonstandard: "Past",
	},
	makuhita: {
		isNonstandard: "Past",
	},
	hariyama: {
		isNonstandard: "Past",
	},
	azurill: {
		isNonstandard: "Past",
	},
	nosepass: {
		isNonstandard: "Past",
	},
	sableye: {
		isNonstandard: null,
	},
	sableyemega: {
		isNonstandard: null,
	},
	mawile: {
		isNonstandard: null,
	},
	mawilemega: {
		isNonstandard: null,
	},
	aron: {
		isNonstandard: null,
	},
	lairon: {
		isNonstandard: null,
	},
	aggron: {
		isNonstandard: null,
	},
	aggronmega: {
		isNonstandard: null,
	},
	meditite: {
		isNonstandard: null,
	},
	medicham: {
		isNonstandard: null,
	},
	medichammega: {
		isNonstandard: null,
	},
	electrike: {
		isNonstandard: null,
	},
	manectric: {
		isNonstandard: null,
	},
	manectricmega: {
		isNonstandard: null,
	},
	plusle: {
		isNonstandard: "Past",
	},
	minun: {
		isNonstandard: "Past",
	},
	volbeat: {
		isNonstandard: "Past",
	},
	illumise: {
		isNonstandard: "Past",
	},
	roselia: {
		isNonstandard: null,
	},
	gulpin: {
		isNonstandard: null,
	},
	swalot: {
		isNonstandard: null,
	},
	carvanha: {
		isNonstandard: null,
	},
	sharpedo: {
		isNonstandard: null,
	},
	sharpedomega: {
		isNonstandard: null,
	},
	numel: {
		isNonstandard: null,
	},
	camerupt: {
		isNonstandard: null,
	},
	cameruptmega: {
		isNonstandard: null,
	},
	torkoal: {
		isNonstandard: "Past",
	},
	spoink: {
		isNonstandard: null,
	},
	grumpig: {
		isNonstandard: null,
	},
	trapinch: {
		isNonstandard: "Past",
	},
	vibrava: {
		isNonstandard: "Past",
	},
	flygon: {
		isNonstandard: "Past",
	},
	cacnea: {
		isNonstandard: "Past",
	},
	cacturne: {
		isNonstandard: "Past",
	},
	swablu: {
		isNonstandard: null,
	},
	altaria: {
		isNonstandard: null,
	},
	altariamega: {
		isNonstandard: null,
	},
	zangoose: {
		isNonstandard: null,
	},
	seviper: {
		isNonstandard: null,
	},
	barboach: {
		isNonstandard: "Past",
	},
	whiscash: {
		isNonstandard: "Past",
	},
	corphish: {
		isNonstandard: "Past",
	},
	crawdaunt: {
		isNonstandard: "Past",
	},
	feebas: {
		isNonstandard: null,
	},
	milotic: {
		isNonstandard: null,
	},
	kecleon: {
		isNonstandard: null,
	},
	shuppet: {
		isNonstandard: null,
	},
	banette: {
		isNonstandard: null,
	},
	banettemega: {
		isNonstandard: null,
	},
	duskull: {
		isNonstandard: "Past",
	},
	dusclops: {
		isNonstandard: "Past",
	},
	tropius: {
		isNonstandard: "Past",
	},
	chingling: {
		isNonstandard: null,
	},
	chimecho: {
		isNonstandard: null,
	},
	chimechomega: {
		isNonstandard: null,
	},
	absol: {
		isNonstandard: null,
	},
	absolmega: {
		isNonstandard: null,
	},
	absolmegaz: {
		isNonstandard: null,
	},
	snorunt: {
		isNonstandard: null,
	},
	glalie: {
		isNonstandard: null,
	},
	glaliemega: {
		isNonstandard: null,
	},
	luvdisc: {
		isNonstandard: "Past",
	},
	bagon: {
		isNonstandard: null,
	},
	shelgon: {
		isNonstandard: null,
	},
	salamence: {
		isNonstandard: null,
	},
	salamencemega: {
		isNonstandard: null,
	},
	beldum: {
		isNonstandard: null,
	},
	metang: {
		isNonstandard: null,
	},
	metagross: {
		isNonstandard: null,
	},
	metagrossmega: {
		isNonstandard: null,
	},
	regirock: {
		isNonstandard: "Past",
	},
	regice: {
		isNonstandard: "Past",
	},
	registeel: {
		isNonstandard: "Past",
	},
	latias: {
		isNonstandard: null,
	},
	latiasmega: {
		isNonstandard: null,
	},
	latios: {
		isNonstandard: null,
	},
	latiosmega: {
		isNonstandard: null,
	},
	kyogre: {
		isNonstandard: null,
	},
	kyogreprimal: {
		isNonstandard: null,
	},
	groudon: {
		isNonstandard: null,
	},
	groudonprimal: {
		isNonstandard: null,
	},
	rayquaza: {
		isNonstandard: null,
	},
	rayquazamega: {
		isNonstandard: null,
	},
	jirachi: {
		isNonstandard: "Past",
	},
	deoxys: {
		isNonstandard: "Past",
	},
	deoxysattack: {
		isNonstandard: "Past",
	},
	deoxysdefense: {
		isNonstandard: "Past",
	},
	deoxysspeed: {
		isNonstandard: "Past",
	},
	turtwig: {
		isNonstandard: "Past",
	},
	grotle: {
		isNonstandard: "Past",
	},
	torterra: {
		isNonstandard: "Past",
	},
	chimchar: {
		isNonstandard: "Past",
	},
	monferno: {
		isNonstandard: "Past",
	},
	infernape: {
		isNonstandard: "Past",
	},
	piplup: {
		isNonstandard: "Past",
	},
	prinplup: {
		isNonstandard: "Past",
	},
	empoleon: {
		isNonstandard: "Past",
	},
	starly: {
		isNonstandard: null,
	},
	staravia: {
		isNonstandard: null,
	},
	staraptor: {
		isNonstandard: null,
	},
	staraptormega: {
		isNonstandard: null,
	},
	kricketot: {
		isNonstandard: "Past",
	},
	kricketune: {
		isNonstandard: "Past",
	},
	shinx: {
		isNonstandard: "Past",
	},
	luxio: {
		isNonstandard: "Past",
	},
	luxray: {
		isNonstandard: "Past",
	},
	budew: {
		isNonstandard: null,
	},
	roserade: {
		isNonstandard: null,
	},
	cranidos: {
		isNonstandard: "Past",
	},
	rampardos: {
		isNonstandard: "Past",
	},
	shieldon: {
		isNonstandard: "Past",
	},
	bastiodon: {
		isNonstandard: "Past",
	},
	combee: {
		isNonstandard: "Past",
	},
	vespiquen: {
		isNonstandard: "Past",
	},
	pachirisu: {
		isNonstandard: "Past",
	},
	buizel: {
		isNonstandard: "Past",
	},
	floatzel: {
		isNonstandard: "Past",
	},
	shellos: {
		isNonstandard: "Past",
	},
	gastrodon: {
		isNonstandard: "Past",
	},
	ambipom: {
		isNonstandard: "Past",
	},
	drifloon: {
		isNonstandard: "Past",
	},
	drifblim: {
		isNonstandard: "Past",
	},
	buneary: {
		isNonstandard: null,
	},
	lopunny: {
		isNonstandard: null,
	},
	lopunnymega: {
		isNonstandard: null,
	},
	mismagius: {
		isNonstandard: "Past",
	},
	honchkrow: {
		isNonstandard: "Past",
	},
	stunky: {
		isNonstandard: "Past",
	},
	skuntank: {
		isNonstandard: "Past",
	},
	bronzor: {
		isNonstandard: "Past",
	},
	bronzong: {
		isNonstandard: "Past",
	},
	bonsly: {
		isNonstandard: "Past",
	},
	happiny: {
		isNonstandard: "Past",
	},
	spiritomb: {
		isNonstandard: "Past",
	},
	gible: {
		isNonstandard: null,
	},
	gabite: {
		isNonstandard: null,
	},
	garchomp: {
		isNonstandard: null,
	},
	garchompmega: {
		isNonstandard: null,
	},
	garchompmegaz: {
		isNonstandard: "Unobtainable",
	},
	munchlax: {
		isNonstandard: "Past",
	},
	riolu: {
		isNonstandard: null,
	},
	lucario: {
		isNonstandard: null,
	},
	lucariomega: {
		isNonstandard: null,
	},
	lucariomegaz: {
		isNonstandard: null,
	},
	hippopotas: {
		isNonstandard: null,
	},
	hippowdon: {
		isNonstandard: null,
	},
	croagunk: {
		isNonstandard: "Past",
	},
	toxicroak: {
		isNonstandard: "Past",
	},
	finneon: {
		isNonstandard: "Past",
	},
	lumineon: {
		isNonstandard: "Past",
	},
	snover: {
		isNonstandard: null,
	},
	abomasnow: {
		isNonstandard: null,
	},
	abomasnowmega: {
		isNonstandard: null,
	},
	weavile: {
		isNonstandard: "Past",
	},
	rhyperior: {
		isNonstandard: "Past",
	},
	electivire: {
		isNonstandard: "Past",
	},
	magmortar: {
		isNonstandard: "Past",
	},
	yanmega: {
		isNonstandard: "Past",
	},
	leafeon: {
		isNonstandard: null,
	},
	glaceon: {
		isNonstandard: null,
	},
	gliscor: {
		isNonstandard: "Past",
	},
	mamoswine: {
		isNonstandard: "Past",
	},
	gallade: {
		isNonstandard: null,
	},
	gallademega: {
		isNonstandard: null,
	},
	probopass: {
		isNonstandard: "Past",
	},
	dusknoir: {
		isNonstandard: "Past",
	},
	froslass: {
		isNonstandard: null,
	},
	froslassmega: {
		isNonstandard: null,
	},
	rotom: {
		isNonstandard: null,
	},
	rotomheat: {
		isNonstandard: null,
	},
	rotomwash: {
		isNonstandard: null,
	},
	rotomfrost: {
		isNonstandard: null,
	},
	rotomfan: {
		isNonstandard: null,
	},
	rotommow: {
		isNonstandard: null,
	},
	uxie: {
		isNonstandard: "Past",
	},
	mesprit: {
		isNonstandard: "Past",
	},
	azelf: {
		isNonstandard: "Past",
	},
	dialga: {
		isNonstandard: "Past",
	},
	dialgaorigin: {
		isNonstandard: "Past",
	},
	palkia: {
		isNonstandard: "Past",
	},
	palkiaorigin: {
		isNonstandard: "Past",
	},
	heatran: {
		isNonstandard: null,
	},
	heatranmega: {
		isNonstandard: null,
	},
	regigigas: {
		isNonstandard: "Past",
	},
	giratina: {
		isNonstandard: "Past",
	},
	giratinaorigin: {
		isNonstandard: "Past",
	},
	cresselia: {
		isNonstandard: "Past",
	},
	phione: {
		isNonstandard: "Past",
	},
	manaphy: {
		isNonstandard: "Past",
	},
	darkrai: {
		isNonstandard: null,
	},
	darkraimega: {
		isNonstandard: null,
	},
	shaymin: {
		isNonstandard: "Past",
	},
	shayminsky: {
		isNonstandard: "Past",
	},
	arceus: {
		isNonstandard: "Past",
	},
	arceusbug: {
		isNonstandard: "Past",
	},
	arceusdark: {
		isNonstandard: "Past",
	},
	arceusdragon: {
		isNonstandard: "Past",
	},
	arceuselectric: {
		isNonstandard: "Past",
	},
	arceusfairy: {
		isNonstandard: "Past",
	},
	arceusfighting: {
		isNonstandard: "Past",
	},
	arceusfire: {
		isNonstandard: "Past",
	},
	arceusflying: {
		isNonstandard: "Past",
	},
	arceusghost: {
		isNonstandard: "Past",
	},
	arceusgrass: {
		isNonstandard: "Past",
	},
	arceusground: {
		isNonstandard: "Past",
	},
	arceusice: {
		isNonstandard: "Past",
	},
	arceuspoison: {
		isNonstandard: "Past",
	},
	arceuspsychic: {
		isNonstandard: "Past",
	},
	arceusrock: {
		isNonstandard: "Past",
	},
	arceussteel: {
		isNonstandard: "Past",
	},
	arceuswater: {
		isNonstandard: "Past",
	},
	snivy: {
		isNonstandard: "Past",
	},
	servine: {
		isNonstandard: "Past",
	},
	serperior: {
		isNonstandard: "Past",
	},
	tepig: {
		isNonstandard: null,
	},
	pignite: {
		isNonstandard: null,
	},
	emboar: {
		isNonstandard: null,
	},
	emboarmega: {
		isNonstandard: null,
	},
	oshawott: {
		isNonstandard: "Past",
	},
	dewott: {
		isNonstandard: "Past",
	},
	samurott: {
		isNonstandard: "Past",
	},
	samurotthisui: {
		isNonstandard: "Past",
	},
	patrat: {
		isNonstandard: null,
	},
	watchog: {
		isNonstandard: null,
	},
	purrloin: {
		isNonstandard: null,
	},
	liepard: {
		isNonstandard: null,
	},
	pansage: {
		isNonstandard: null,
	},
	simisage: {
		isNonstandard: null,
	},
	pansear: {
		isNonstandard: null,
	},
	simisear: {
		isNonstandard: null,
	},
	panpour: {
		isNonstandard: null,
	},
	simipour: {
		isNonstandard: null,
	},
	munna: {
		isNonstandard: null,
	},
	musharna: {
		isNonstandard: null,
	},
	blitzle: {
		isNonstandard: "Past",
	},
	zebstrika: {
		isNonstandard: "Past",
	},
	drilbur: {
		isNonstandard: null,
	},
	excadrill: {
		isNonstandard: null,
	},
	excadrillmega: {
		isNonstandard: null,
	},
	audino: {
		isNonstandard: null,
	},
	audinomega: {
		isNonstandard: null,
	},
	timburr: {
		isNonstandard: "Past",
	},
	gurdurr: {
		isNonstandard: "Past",
	},
	conkeldurr: {
		isNonstandard: "Past",
	},
	sewaddle: {
		isNonstandard: "Past",
	},
	swadloon: {
		isNonstandard: "Past",
	},
	leavanny: {
		isNonstandard: "Past",
	},
	throh: {
		isNonstandard: null,
	},
	sawk: {
		isNonstandard: null,
	},
	venipede: {
		isNonstandard: null,
	},
	whirlipede: {
		isNonstandard: null,
	},
	scolipede: {
		isNonstandard: null,
	},
	scolipedemega: {
		isNonstandard: null,
	},
	cottonee: {
		isNonstandard: "Past",
	},
	whimsicott: {
		isNonstandard: "Past",
	},
	petilil: {
		isNonstandard: "Past",
	},
	lilligant: {
		isNonstandard: "Past",
	},
	lilliganthisui: {
		isNonstandard: "Past",
	},
	basculin: {
		isNonstandard: "Past",
	},
	basculinbluestriped: {
		isNonstandard: "Past",
	},
	basculinwhitestriped: {
		isNonstandard: "Past",
	},
	sandile: {
		isNonstandard: null,
	},
	krokorok: {
		isNonstandard: null,
	},
	krookodile: {
		isNonstandard: null,
	},
	scraggy: {
		isNonstandard: null,
	},
	scrafty: {
		isNonstandard: null,
	},
	scraftymega: {
		isNonstandard: null,
	},
	yamask: {
		isNonstandard: null,
	},
	yamaskgalar: {
		isNonstandard: null,
	},
	cofagrigus: {
		isNonstandard: null,
	},
	runerigus: {
		isNonstandard: null,
	},
	trubbish: {
		isNonstandard: null,
	},
	garbodor: {
		isNonstandard: null,
	},
	zorua: {
		isNonstandard: "Past",
	},
	zoruahisui: {
		isNonstandard: "Past",
	},
	zoroark: {
		isNonstandard: "Past",
	},
	zoroarkhisui: {
		isNonstandard: "Past",
	},
	minccino: {
		isNonstandard: "Past",
	},
	cinccino: {
		isNonstandard: "Past",
	},
	gothita: {
		isNonstandard: "Past",
	},
	gothorita: {
		isNonstandard: "Past",
	},
	gothitelle: {
		isNonstandard: "Past",
	},
	solosis: {
		isNonstandard: "Past",
	},
	duosion: {
		isNonstandard: "Past",
	},
	reuniclus: {
		isNonstandard: "Past",
	},
	ducklett: {
		isNonstandard: "Past",
	},
	swanna: {
		isNonstandard: "Past",
	},
	vanillite: {
		isNonstandard: null,
	},
	vanillish: {
		isNonstandard: null,
	},
	vanilluxe: {
		isNonstandard: null,
	},
	deerling: {
		isNonstandard: "Past",
	},
	sawsbuck: {
		isNonstandard: "Past",
	},
	emolga: {
		isNonstandard: null,
	},
	foongus: {
		isNonstandard: null,
	},
	amoonguss: {
		isNonstandard: null,
	},
	alomomola: {
		isNonstandard: "Past",
	},
	joltik: {
		isNonstandard: "Past",
	},
	galvantula: {
		isNonstandard: "Past",
	},
	tynamo: {
		isNonstandard: null,
	},
	eelektrik: {
		isNonstandard: null,
	},
	eelektross: {
		isNonstandard: null,
	},
	eelektrossmega: {
		isNonstandard: null,
	},
	litwick: {
		isNonstandard: null,
	},
	lampent: {
		isNonstandard: null,
	},
	chandelure: {
		isNonstandard: null,
	},
	chandeluremega: {
		isNonstandard: null,
	},
	axew: {
		isNonstandard: "Past",
	},
	fraxure: {
		isNonstandard: "Past",
	},
	haxorus: {
		isNonstandard: "Past",
	},
	cubchoo: {
		isNonstandard: "Past",
	},
	beartic: {
		isNonstandard: "Past",
	},
	cryogonal: {
		isNonstandard: null,
	},
	stunfisk: {
		isNonstandard: null,
	},
	stunfiskgalar: {
		isNonstandard: null,
	},
	mienfoo: {
		isNonstandard: "Past",
	},
	mienshao: {
		isNonstandard: "Past",
	},
	golett: {
		isNonstandard: null,
	},
	golurk: {
		isNonstandard: null,
	},
	golurkmega: {
		isNonstandard: null,
	},
	pawniard: {
		isNonstandard: "Past",
	},
	bisharp: {
		isNonstandard: "Past",
	},
	rufflet: {
		isNonstandard: "Past",
	},
	braviary: {
		isNonstandard: "Past",
	},
	braviaryhisui: {
		isNonstandard: "Past",
	},
	vullaby: {
		isNonstandard: "Past",
	},
	mandibuzz: {
		isNonstandard: "Past",
	},
	deino: {
		isNonstandard: "Past",
	},
	zweilous: {
		isNonstandard: "Past",
	},
	hydreigon: {
		isNonstandard: "Past",
	},
	larvesta: {
		isNonstandard: "Past",
	},
	volcarona: {
		isNonstandard: "Past",
	},
	cobalion: {
		isNonstandard: null,
	},
	terrakion: {
		isNonstandard: null,
	},
	virizion: {
		isNonstandard: null,
	},
	tornadus: {
		isNonstandard: "Past",
	},
	tornadustherian: {
		isNonstandard: "Past",
	},
	thundurus: {
		isNonstandard: "Past",
	},
	thundurustherian: {
		isNonstandard: "Past",
	},
	reshiram: {
		isNonstandard: "Past",
	},
	zekrom: {
		isNonstandard: "Past",
	},
	landorus: {
		isNonstandard: "Past",
	},
	landorustherian: {
		isNonstandard: "Past",
	},
	kyurem: {
		isNonstandard: "Past",
	},
	kyuremblack: {
		isNonstandard: "Past",
	},
	kyuremwhite: {
		isNonstandard: "Past",
	},
	keldeo: {
		isNonstandard: null,
	},
	keldeoresolute: {
		isNonstandard: null,
	},
	meloetta: {
		isNonstandard: null,
	},
	meloettapirouette: {
		isNonstandard: null,
	},
	genesect: {
		isNonstandard: null,
	},
	genesectdouse: {
	},
	genesectshock: {
	},
	genesectburn: {
	},
	genesectchill: {
	},
	chespin: {
		isNonstandard: null,
	},
	quilladin: {
		isNonstandard: null,
	},
	chesnaught: {
		isNonstandard: null,
	},
	chesnaughtmega: {
		isNonstandard: null,
	},
	fennekin: {
		isNonstandard: null,
	},
	braixen: {
		isNonstandard: null,
	},
	delphox: {
		isNonstandard: null,
	},
	delphoxmega: {
		isNonstandard: null,
	},
	froakie: {
		isNonstandard: null,
	},
	frogadier: {
		isNonstandard: null,
	},
	greninja: {
		isNonstandard: null,
	},
	greninjabond: {
		isNonstandard: "Unobtainable",
	},
	greninjamega: {
		isNonstandard: null,
	},
	bunnelby: {
		isNonstandard: null,
	},
	diggersby: {
		isNonstandard: null,
	},
	fletchling: {
		isNonstandard: null,
	},
	fletchinder: {
		isNonstandard: null,
	},
	talonflame: {
		isNonstandard: null,
	},
	scatterbug: {
		isNonstandard: null,
	},
	spewpa: {
		isNonstandard: null,
	},
	vivillon: {
		isNonstandard: null,
	},
	vivillonfancy: {
		isNonstandard: null,
	},
	vivillonpokeball: {
		isNonstandard: null,
	},
	litleo: {
		isNonstandard: null,
	},
	pyroar: {
		isNonstandard: null,
	},
	pyroarmega: {
		isNonstandard: null,
	},
	flabebe: {
		isNonstandard: null,
	},
	floette: {
		isNonstandard: null,
	},
	floetteeternal: {
		isNonstandard: null,
	},
	floettemega: {
		isNonstandard: null,
	},
	florges: {
		isNonstandard: null,
	},
	skiddo: {
		isNonstandard: null,
	},
	gogoat: {
		isNonstandard: null,
	},
	pancham: {
		isNonstandard: null,
	},
	pangoro: {
		isNonstandard: null,
	},
	furfrou: {
		isNonstandard: null,
	},
	espurr: {
		isNonstandard: null,
	},
	meowstic: {
		isNonstandard: null,
	},
	meowsticf: {
		isNonstandard: null,
	},
	meowsticmmega: {
		isNonstandard: null,
	},
	meowsticfmega: {
		isNonstandard: null,
	},
	honedge: {
		isNonstandard: null,
	},
	doublade: {
		isNonstandard: null,
	},
	aegislash: {
		isNonstandard: null,
	},
	aegislashblade: {
	},
	spritzee: {
		isNonstandard: null,
	},
	aromatisse: {
		isNonstandard: null,
	},
	swirlix: {
		isNonstandard: null,
	},
	slurpuff: {
		isNonstandard: null,
	},
	inkay: {
		isNonstandard: null,
	},
	malamar: {
		isNonstandard: null,
	},
	malamarmega: {
		isNonstandard: null,
	},
	binacle: {
		isNonstandard: null,
	},
	barbaracle: {
		isNonstandard: null,
	},
	barbaraclemega: {
		isNonstandard: null,
	},
	skrelp: {
		isNonstandard: null,
	},
	dragalge: {
		isNonstandard: null,
	},
	dragalgemega: {
		isNonstandard: null,
	},
	clauncher: {
		isNonstandard: null,
	},
	clawitzer: {
		isNonstandard: null,
	},
	helioptile: {
		isNonstandard: null,
	},
	heliolisk: {
		isNonstandard: null,
	},
	tyrunt: {
		isNonstandard: null,
	},
	tyrantrum: {
		isNonstandard: null,
	},
	amaura: {
		isNonstandard: null,
	},
	aurorus: {
		isNonstandard: null,
	},
	sylveon: {
		isNonstandard: null,
	},
	hawlucha: {
		isNonstandard: null,
	},
	hawluchamega: {
		isNonstandard: null,
	},
	dedenne: {
		isNonstandard: null,
	},
	carbink: {
		isNonstandard: null,
	},
	goomy: {
		isNonstandard: null,
	},
	sliggoo: {
		isNonstandard: null,
	},
	sliggoohisui: {
		isNonstandard: null,
	},
	goodra: {
		isNonstandard: null,
	},
	goodrahisui: {
		isNonstandard: null,
	},
	klefki: {
		isNonstandard: null,
	},
	phantump: {
		isNonstandard: null,
	},
	trevenant: {
		isNonstandard: null,
	},
	pumpkaboo: {
		isNonstandard: null,
	},
	pumpkaboosmall: {
		isNonstandard: null,
	},
	pumpkaboolarge: {
		isNonstandard: null,
	},
	pumpkaboosuper: {
		isNonstandard: null,
	},
	gourgeist: {
		isNonstandard: null,
	},
	gourgeistsmall: {
		isNonstandard: null,
	},
	gourgeistlarge: {
		isNonstandard: null,
	},
	gourgeistsuper: {
		isNonstandard: null,
	},
	bergmite: {
		isNonstandard: null,
	},
	avalugg: {
		isNonstandard: null,
	},
	avalugghisui: {
		isNonstandard: null,
	},
	noibat: {
		isNonstandard: null,
	},
	noivern: {
		isNonstandard: null,
	},
	xerneas: {
		isNonstandard: null,
	},
	xerneasneutral: {
		isNonstandard: "Custom", // can't be used in battle
	},
	yveltal: {
		isNonstandard: null,
	},
	zygarde: {
		isNonstandard: null,
	},
	zygarde10: {
		isNonstandard: null,
	},
	zygardecomplete: {
		isNonstandard: null,
	},
	zygardemega: {
		isNonstandard: null,
	},
	diancie: {
		isNonstandard: null,
	},
	dianciemega: {
		isNonstandard: null,
	},
	hoopa: {
		isNonstandard: null,
	},
	hoopaunbound: {
		isNonstandard: null,
	},
	volcanion: {
		isNonstandard: null,
	},
	rowlet: {
		isNonstandard: "Past",
	},
	dartrix: {
		isNonstandard: "Past",
	},
	decidueye: {
		isNonstandard: "Past",
	},
	decidueyehisui: {
		isNonstandard: "Past",
	},
	litten: {
		isNonstandard: "Past",
	},
	torracat: {
		isNonstandard: "Past",
	},
	incineroar: {
		isNonstandard: "Past",
	},
	popplio: {
		isNonstandard: "Past",
	},
	brionne: {
		isNonstandard: "Past",
	},
	primarina: {
		isNonstandard: "Past",
	},
	pikipek: {
		isNonstandard: "Past",
	},
	trumbeak: {
		isNonstandard: "Past",
	},
	toucannon: {
		isNonstandard: "Past",
	},
	yungoos: {
		isNonstandard: "Past",
	},
	gumshoos: {
		isNonstandard: "Past",
	},
	grubbin: {
		isNonstandard: "Past",
	},
	charjabug: {
		isNonstandard: "Past",
	},
	vikavolt: {
		isNonstandard: "Past",
	},
	crabrawler: {
		isNonstandard: null,
	},
	crabominable: {
		isNonstandard: null,
	},
	crabominablemega: {
		isNonstandard: null,
	},
	wimpod: {
		isNonstandard: null,
	},
	golisopod: {
		isNonstandard: null,
	},
	golisopodmega: {
		isNonstandard: null,
	},
	oricorio: {
		isNonstandard: "Past",
	},
	oricoriopompom: {
		isNonstandard: "Past",
	},
	oricoriopau: {
		isNonstandard: "Past",
	},
	oricoriosensu: {
		isNonstandard: "Past",
	},
	cutiefly: {
		isNonstandard: "Past",
	},
	ribombee: {
		isNonstandard: "Past",
	},
	rockruff: {
		isNonstandard: "Past",
	},
	rockruffdusk: {
		isNonstandard: "Past",
	},
	lycanroc: {
		isNonstandard: "Past",
	},
	lycanrocmidnight: {
		isNonstandard: "Past",
	},
	lycanrocdusk: {
		isNonstandard: "Past",
	},
	mareanie: {
		isNonstandard: "Past",
	},
	toxapex: {
		isNonstandard: "Past",
	},
	mudbray: {
		isNonstandard: "Past",
	},
	mudsdale: {
		isNonstandard: "Past",
	},
	dewpider: {
		isNonstandard: "Past",
	},
	araquanid: {
		isNonstandard: "Past",
	},
	fomantis: {
		isNonstandard: "Past",
	},
	lurantis: {
		isNonstandard: "Past",
	},
	salandit: {
		isNonstandard: "Past",
	},
	salazzle: {
		isNonstandard: "Past",
	},
	bounsweet: {
		isNonstandard: "Past",
	},
	steenee: {
		isNonstandard: "Past",
	},
	tsareena: {
		isNonstandard: "Past",
	},
	comfey: {
		isNonstandard: "Past",
	},
	oranguru: {
		isNonstandard: "Past",
	},
	passimian: {
		isNonstandard: "Past",
	},
	sandygast: {
		isNonstandard: null,
	},
	palossand: {
		isNonstandard: null,
	},
	minior: {
		isNonstandard: "Past",
	},
	miniormeteor: {
		isNonstandard: "Past",
	},
	komala: {
		isNonstandard: "Past",
	},
	mimikyu: {
		isNonstandard: null,
	},
	mimikyubusted: {
		isNonstandard: null,
	},
	bruxish: {
		isNonstandard: "Past",
	},
	drampa: {
		isNonstandard: null,
	},
	drampamega: {
		isNonstandard: null,
	},
	jangmoo: {
		isNonstandard: "Past",
	},
	hakamoo: {
		isNonstandard: "Past",
	},
	kommoo: {
		isNonstandard: "Past",
	},
	cosmog: {
		isNonstandard: "Past",
	},
	cosmoem: {
		isNonstandard: "Past",
	},
	solgaleo: {
		isNonstandard: "Past",
	},
	lunala: {
		isNonstandard: "Past",
	},
	necrozma: {
		isNonstandard: "Past",
	},
	necrozmaduskmane: {
		isNonstandard: "Past",
	},
	necrozmadawnwings: {
		isNonstandard: "Past",
	},
	magearna: {
		isNonstandard: null,
	},
	magearnaoriginal: {
		isNonstandard: "Unobtainable",
	},
	magearnamega: {
		isNonstandard: null,
	},
	magearnaoriginalmega: {
		isNonstandard: null,
	},
	marshadow: {
		isNonstandard: null,
	},
	zeraora: {
		isNonstandard: null,
	},
	zeraoramega: {
		isNonstandard: null,
	},
	meltan: {
		isNonstandard: null,
	},
	melmetal: {
		isNonstandard: null,
	},
	grookey: {
		isNonstandard: "Past",
	},
	thwackey: {
		isNonstandard: "Past",
	},
	rillaboom: {
		isNonstandard: "Past",
	},
	scorbunny: {
		isNonstandard: "Past",
	},
	raboot: {
		isNonstandard: "Past",
	},
	cinderace: {
		isNonstandard: "Past",
	},
	sobble: {
		isNonstandard: "Past",
	},
	drizzile: {
		isNonstandard: "Past",
	},
	inteleon: {
		isNonstandard: "Past",
	},
	skwovet: {
		isNonstandard: "Past",
	},
	greedent: {
		isNonstandard: "Past",
	},
	rookidee: {
		isNonstandard: null,
	},
	corvisquire: {
		isNonstandard: null,
	},
	corviknight: {
		isNonstandard: null,
	},
	chewtle: {
		isNonstandard: "Past",
	},
	drednaw: {
		isNonstandard: "Past",
	},
	rolycoly: {
		isNonstandard: "Past",
	},
	carkol: {
		isNonstandard: "Past",
	},
	coalossal: {
		isNonstandard: "Past",
	},
	applin: {
		isNonstandard: "Past",
	},
	flapple: {
		isNonstandard: "Past",
	},
	appletun: {
		isNonstandard: "Past",
	},
	silicobra: {
		isNonstandard: "Past",
	},
	sandaconda: {
		isNonstandard: "Past",
	},
	cramorant: {
		isNonstandard: "Past",
	},
	cramorantgulping: {
		isNonstandard: "Past",
	},
	cramorantgorging: {
		isNonstandard: "Past",
	},
	arrokuda: {
		isNonstandard: "Past",
	},
	barraskewda: {
		isNonstandard: "Past",
	},
	nickit: {
		isNonstandard: null,
	},
	thievul: {
		isNonstandard: null,
	},
	toxel: {
		isNonstandard: null,
	},
	toxtricity: {
		isNonstandard: null,
	},
	toxtricitylowkey: {
	},
	sinistea: {
		isNonstandard: "Past",
	},
	sinisteaantique: {
		isNonstandard: "Past",
	},
	polteageist: {
		isNonstandard: "Past",
	},
	polteageistantique: {
		isNonstandard: "Past",
	},
	hatenna: {
		isNonstandard: "Past",
	},
	hattrem: {
		isNonstandard: "Past",
	},
	hatterene: {
		isNonstandard: "Past",
	},
	impidimp: {
		isNonstandard: "Past",
	},
	morgrem: {
		isNonstandard: "Past",
	},
	grimmsnarl: {
		isNonstandard: "Past",
	},
	milcery: {
		isNonstandard: "Past",
	},
	alcremie: {
		isNonstandard: "Past",
	},
	clobbopus: {
		isNonstandard: null,
	},
	grapploct: {
		isNonstandard: null,
	},
	falinks: {
		isNonstandard: null,
	},
	falinksmega: {
		isNonstandard: null,
	},
	pincurchin: {
		isNonstandard: "Past",
	},
	snom: {
		isNonstandard: "Past",
	},
	frosmoth: {
		isNonstandard: "Past",
	},
	stonjourner: {
		isNonstandard: "Past",
	},
	eiscue: {
		isNonstandard: "Past",
	},
	eiscuenoice: {
		isNonstandard: "Past",
	},
	indeedee: {
		isNonstandard: null,
	},
	indeedeef: {
		isNonstandard: null,
	},
	morpeko: {
		isNonstandard: null,
	},
	morpekohangry: {
	},
	cufant: {
		isNonstandard: "Past",
	},
	copperajah: {
		isNonstandard: "Past",
	},
	duraludon: {
		isNonstandard: "Past",
	},
	dreepy: {
		isNonstandard: "Past",
	},
	drakloak: {
		isNonstandard: "Past",
	},
	dragapult: {
		isNonstandard: "Past",
	},
	zacian: {
		isNonstandard: "Past",
	},
	zaciancrowned: {
		isNonstandard: "Past",
	},
	zamazenta: {
		isNonstandard: "Past",
	},
	zamazentacrowned: {
		isNonstandard: "Past",
	},
	eternatus: {
		isNonstandard: "Past",
	},
	kubfu: {
		isNonstandard: "Past",
	},
	urshifu: {
		isNonstandard: "Past",
	},
	urshifurapidstrike: {
		isNonstandard: "Past",
	},
	zarude: {
		isNonstandard: "Past",
	},
	zarudedada: {
		isNonstandard: "Past",
	},
	regieleki: {
		isNonstandard: "Past",
	},
	regidrago: {
		isNonstandard: "Past",
	},
	glastrier: {
		isNonstandard: "Past",
	},
	spectrier: {
		isNonstandard: "Past",
	},
	calyrex: {
		isNonstandard: "Past",
	},
	calyrexice: {
		isNonstandard: "Past",
	},
	calyrexshadow: {
		isNonstandard: "Past",
	},
	wyrdeer: {
		isNonstandard: "Past",
	},
	kleavor: {
		isNonstandard: null,
	},
	ursaluna: {
		isNonstandard: "Past",
	},
	ursalunabloodmoon: {
		isNonstandard: "Past",
	},
	basculegion: {
		isNonstandard: "Past",
	},
	basculegionf: {
		isNonstandard: "Past",
	},
	sneasler: {
		isNonstandard: "Past",
	},
	enamorus: {
		isNonstandard: "Past",
	},
	enamorustherian: {
		isNonstandard: "Past",
	},
	sprigatito: {
		isNonstandard: "Past",
	},
	floragato: {
		isNonstandard: "Past",
	},
	meowscarada: {
		isNonstandard: "Past",
	},
	fuecoco: {
		isNonstandard: "Past",
	},
	crocalor: {
		isNonstandard: "Past",
	},
	skeledirge: {
		isNonstandard: "Past",
	},
	quaxly: {
		isNonstandard: "Past",
	},
	quaxwell: {
		isNonstandard: "Past",
	},
	quaquaval: {
		isNonstandard: "Past",
	},
	lechonk: {
		isNonstandard: "Past",
	},
	oinkologne: {
		isNonstandard: "Past",
	},
	oinkolognef: {
		isNonstandard: "Past",
	},
	tarountula: {
		isNonstandard: "Past",
	},
	spidops: {
		isNonstandard: "Past",
	},
	nymble: {
		isNonstandard: "Past",
	},
	lokix: {
		isNonstandard: "Past",
	},
	pawmi: {
		isNonstandard: "Past",
	},
	pawmo: {
		isNonstandard: "Past",
	},
	pawmot: {
		isNonstandard: "Past",
	},
	tandemaus: {
		isNonstandard: "Past",
	},
	maushold: {
		isNonstandard: "Past",
	},
	mausholdfour: {
		isNonstandard: "Past",
	},
	fidough: {
		isNonstandard: null,
	},
	dachsbun: {
		isNonstandard: null,
	},
	smoliv: {
		isNonstandard: "Past",
	},
	dolliv: {
		isNonstandard: "Past",
	},
	arboliva: {
		isNonstandard: "Past",
	},
	squawkabilly: {
		isNonstandard: null,
	},
	squawkabillyblue: {
	},
	squawkabillywhite: {
	},
	squawkabillyyellow: {
	},
	nacli: {
		isNonstandard: null,
	},
	naclstack: {
		isNonstandard: null,
	},
	garganacl: {
		isNonstandard: null,
	},
	charcadet: {
		isNonstandard: null,
	},
	armarouge: {
		isNonstandard: null,
	},
	ceruledge: {
		isNonstandard: null,
	},
	tadbulb: {
		isNonstandard: "Past",
	},
	bellibolt: {
		isNonstandard: "Past",
	},
	wattrel: {
		isNonstandard: "Past",
	},
	kilowattrel: {
		isNonstandard: "Past",
	},
	maschiff: {
		isNonstandard: null,
	},
	mabosstiff: {
		isNonstandard: null,
	},
	shroodle: {
		isNonstandard: null,
	},
	grafaiai: {
		isNonstandard: null,
	},
	bramblin: {
		isNonstandard: "Past",
	},
	brambleghast: {
		isNonstandard: "Past",
	},
	toedscool: {
		isNonstandard: "Past",
	},
	toedscruel: {
		isNonstandard: "Past",
	},
	klawf: {
		isNonstandard: "Past",
	},
	capsakid: {
		isNonstandard: null,
	},
	scovillain: {
		isNonstandard: null,
	},
	scovillainmega: {
		isNonstandard: null,
	},
	rellor: {
		isNonstandard: "Past",
	},
	rabsca: {
		isNonstandard: "Past",
	},
	flittle: {
		isNonstandard: "Past",
	},
	espathra: {
		isNonstandard: "Past",
	},
	tinkatink: {
		isNonstandard: null,
	},
	tinkatuff: {
		isNonstandard: null,
	},
	tinkaton: {
		isNonstandard: null,
	},
	wiglett: {
		isNonstandard: "Past",
	},
	wugtrio: {
		isNonstandard: "Past",
	},
	bombirdier: {
		isNonstandard: "Past",
	},
	finizen: {
		isNonstandard: "Past",
	},
	palafin: {
		isNonstandard: "Past",
	},
	palafinhero: {
		isNonstandard: "Past",
	},
	varoom: {
		isNonstandard: "Past",
	},
	revavroom: {
		isNonstandard: "Past",
	},
	cyclizar: {
		isNonstandard: null,
	},
	orthworm: {
		isNonstandard: "Past",
	},
	glimmet: {
		isNonstandard: null,
	},
	glimmora: {
		isNonstandard: null,
	},
	glimmoramega: {
		isNonstandard: null,
	},
	greavard: {
		isNonstandard: null,
	},
	houndstone: {
		isNonstandard: null,
	},
	flamigo: {
		isNonstandard: null,
	},
	cetoddle: {
		isNonstandard: "Past",
	},
	cetitan: {
		isNonstandard: "Past",
	},
	veluza: {
		isNonstandard: "Past",
	},
	dondozo: {
		isNonstandard: null,
	},
	tatsugiri: {
		isNonstandard: null,
	},
	tatsugiridroopy: {
	},
	tatsugiristretchy: {
	},
	tatsugiricurlymega: {
		isNonstandard: null,
	},
	tatsugiridroopymega: {
		isNonstandard: null,
	},
	tatsugiristretchymega: {
		isNonstandard: null,
	},
	clodsire: {
		isNonstandard: "Past",
	},
	farigiraf: {
		isNonstandard: "Past",
	},
	dudunsparce: {
		isNonstandard: "Past",
	},
	dudunsparcethreesegment: {
		isNonstandard: "Past",
	},
	kingambit: {
		isNonstandard: "Past",
	},
	greattusk: {
		isNonstandard: "Past",
	},
	screamtail: {
		isNonstandard: "Past",
	},
	brutebonnet: {
		isNonstandard: "Past",
	},
	fluttermane: {
		isNonstandard: "Past",
	},
	slitherwing: {
		isNonstandard: "Past",
	},
	sandyshocks: {
		isNonstandard: "Past",
	},
	irontreads: {
		isNonstandard: "Past",
	},
	ironbundle: {
		isNonstandard: "Past",
	},
	ironhands: {
		isNonstandard: "Past",
	},
	ironjugulis: {
		isNonstandard: "Past",
	},
	ironmoth: {
		isNonstandard: "Past",
	},
	ironthorns: {
		isNonstandard: "Past",
	},
	frigibax: {
		isNonstandard: null,
	},
	arctibax: {
		isNonstandard: null,
	},
	baxcalibur: {
		isNonstandard: null,
	},
	baxcaliburmega: {
		isNonstandard: null,
	},
	gimmighoul: {
		isNonstandard: null,
	},
	gimmighoulroaming: {
		isNonstandard: null,
	},
	gholdengo: {
		isNonstandard: null,
	},
	wochien: {
		isNonstandard: "Past",
	},
	chienpao: {
		isNonstandard: "Past",
	},
	tinglu: {
		isNonstandard: "Past",
	},
	chiyu: {
		isNonstandard: "Past",
	},
	roaringmoon: {
		isNonstandard: "Past",
	},
	ironvaliant: {
		isNonstandard: "Past",
	},
	koraidon: {
		isNonstandard: "Past",
	},
	miraidon: {
		isNonstandard: "Past",
	},
	walkingwake: {
		isNonstandard: "Past",
	},
	ironleaves: {
		isNonstandard: "Past",
	},
	dipplin: {
		isNonstandard: "Past",
	},
	poltchageist: {
		isNonstandard: "Past",
	},
	poltchageistartisan: {
		isNonstandard: "Past",
	},
	sinistcha: {
		isNonstandard: "Past",
	},
	sinistchamasterpiece: {
		isNonstandard: "Past",
	},
	okidogi: {
		isNonstandard: "Past",
	},
	munkidori: {
		isNonstandard: "Past",
	},
	fezandipiti: {
		isNonstandard: "Past",
	},
	ogerpon: {
		isNonstandard: "Past",
	},
	ogerponwellspring: {
		isNonstandard: "Past",
	},
	ogerponhearthflame: {
		isNonstandard: "Past",
	},
	ogerponcornerstone: {
		isNonstandard: "Past",
	},
	ogerpontealtera: {
		isNonstandard: "Past",
	},
	ogerponwellspringtera: {
		isNonstandard: "Past",
	},
	ogerponhearthflametera: {
		isNonstandard: "Past",
	},
	ogerponcornerstonetera: {
		isNonstandard: "Past",
	},
	archaludon: {
		isNonstandard: "Past",
	},
	hydrapple: {
		isNonstandard: "Past",
	},
	gougingfire: {
		isNonstandard: "Past",
	},
	ragingbolt: {
		isNonstandard: "Past",
	},
	ironboulder: {
		isNonstandard: "Past",
	},
	ironcrown: {
		isNonstandard: "Past",
	},
	terapagos: {
		isNonstandard: "Past",
	},
	terapagosterastal: {
		isNonstandard: "Past",
	},
	terapagosstellar: {
		isNonstandard: "Past",
	},
	pecharunt: {
		isNonstandard: "Past",
	},
};
